import { useState, useEffect } from "react";
import { loadCityListByStateID, loadCountryList, loadStateListbyCountryID } from "../services/locationService";

const useCityList = (editID) => {

    const [cityList, setCityList] = useState([]);
    const [selectedCity, setSelectedCity] = useState(null);
    const [selectedCityID, setSelectedCityID] = useState(null);
    const [isCityDataLoaded, setIsCityDataLoaded] = useState(false);

    // fetch state by country id
    const fetchCityListbyStateID = async (selectedID = null, state_id = null) => {
        const para = { p_companyid: localStorage.getItem("companyid"), p_stateid: state_id, };

        try {
            const data = await loadCityListByStateID(para);
            if (data && data.length > 0) {
                setCityList(data);
                const initialDepartment = data.find((dept) => dept.id === selectedID);

                if (initialDepartment) { // ✅ Corrected check
                    setSelectedCity(initialDepartment);
                    setSelectedCityID(initialDepartment.id);
                    setIsCityDataLoaded(true);
                }

            }
        } catch (error) {
            // CallMessage("error", error.message, "Error");
        }
    };

    // Fetch department data
    const fetchCityList = async (selectedID = null) => {
        const para = { p_companyid: localStorage.getItem("companyid") };

        try {
            const data = await loadCountryList(para);
            if (data && data.length > 0) {
                setCityList(data);
                const initialDepartment = data.find((dept) => dept.id === selectedID);

                if (initialDepartment) { // ✅ Corrected check
                    setSelectedCity(initialDepartment);
                    setSelectedCityID(initialDepartment.id);
                    setIsCityDataLoaded(true);
                }

            }
        } catch (error) {
            // CallMessage("error", error.message, "Error");
        }
    };

    // Load departments when the component mounts
    useEffect(() => {
        if (!isCityDataLoaded && editID === 0) {
            const loadCity = async () => {
                await fetchCityList();
            };
            loadCity();
        }
    }, [isCityDataLoaded, editID]);

    // Function to load department based on selected ID
    const loadCityByID = async (selectedID) => {
        await fetchCityList(selectedID);
    };

    // Function to load department based on selected ID
    const loadCityByStateID = async (selectedID, countryID) => {
        await fetchCityListbyStateID(selectedID, countryID);
    };

    return {
        cityList,
        selectedCity,
        selectedCityID,
        setSelectedCity,
        setSelectedCityID,
        loadCityByID,
        loadCityByStateID
    };
};

export default useCityList;
